import { ToggleButtonGroupProps, ToggleButtonGroup } from '@material-ui/lab';
import * as React from 'react';

export type DSToggleButtonGroupProps = ToggleButtonGroupProps;

export const DSToggleButtonGroup: React.FC<DSToggleButtonGroupProps> = props => <ToggleButtonGroup {...props} />;
DSToggleButtonGroup.displayName = 'DSToggleButtonGroup';
